import Vue from 'vue';
import Auth from '~/plugins/auth';

if (process.client) {
    Vue.use(Auth);
    Vue.auth.setAuthorizationHeaders();
}


//////////////////
// WEBPACK FOOTER
// ./plugins/auth-init.js
// module id = ./plugins/auth-init.js
// module chunks = 54